(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/transaction-history-empty-row.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/transaction-history-empty-row.js');

'use strict';

const {
  TableRow,
  TableCell
} = svs.ui.reactTable;
const TransactionHistoryEmptyRow = () => React.createElement(TableRow, null, React.createElement(TableCell, {
  className: "transaction-history-table-column",
  colspan: "3"
}, React.createElement("div", {
  className: "padding-xs-v"
}, "Finns ingen historik att visa.")));
svs.arena.pages.teams.components.TransactionHistoryEmptyRow = TransactionHistoryEmptyRow;

 })(window);